module.exports = __webpack_public_path__ + "img/UDMUR.c548f862.png";